/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Continue_BtnInputs */

const en_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

const ar_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إستمر`)
};

const de_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weiter`)
};

const es_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const fr_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuer`)
};

const it_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua`)
};

const ja_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`続ける`)
};

const ko_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계속`)
};

const pt_br_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar`)
};

const ru_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить`)
};

const th_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดำเนินการต่อ`)
};

const tr_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devam Et`)
};

const zh_cn_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续`)
};

const zh_tw_continue_btn = /** @type {(inputs: Continue_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繼續`)
};

/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Continue_BtnInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const continue_btn = /** @type {((inputs?: Continue_BtnInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Continue_BtnInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_continue_btn(inputs)
	if (locale === "ar") return ar_continue_btn(inputs)
	if (locale === "de") return de_continue_btn(inputs)
	if (locale === "es") return es_continue_btn(inputs)
	if (locale === "fr") return fr_continue_btn(inputs)
	if (locale === "it") return it_continue_btn(inputs)
	if (locale === "ja") return ja_continue_btn(inputs)
	if (locale === "ko") return ko_continue_btn(inputs)
	if (locale === "pt_br") return pt_br_continue_btn(inputs)
	if (locale === "ru") return ru_continue_btn(inputs)
	if (locale === "th") return th_continue_btn(inputs)
	if (locale === "tr") return tr_continue_btn(inputs)
	if (locale === "zh_cn") return zh_cn_continue_btn(inputs)
	return zh_tw_continue_btn(inputs)
});